import { http } from "../Components/utils/http";

export const useHttp = () => {
  return (...[endpoint, config]: Parameters<typeof http>) =>
    http(endpoint, {
      ...config,
    });
};
